
import { computed } from 'vue'
import { supportPreviewFileType } from '@/utils/fileUpload'

export default {
  name: 'CoursewarePreview',
  props: {
    current: {
      type: Object
    }
  },
  setup (props) {
    const pageState = computed({
      get: () => props.current
    })
    const canPreview = computed(() => {
      if (!props?.current?.url) {
        return false
      }
      if (pageState.value.type === 'image') {
        return true
      }
      const index = props.current.url.lastIndexOf('.')
      const fileSuffix = props.current.url.substr(index + 1)
      return supportPreviewFileType.includes(fileSuffix)
    })
    const description = computed(() => {
      if (['audio', 'video'].includes(props.current.type) && props.current.url) {
        const index = props.current.url.lastIndexOf('.')
        const fileSuffix = props.current.url.substr(index + 1)
        if (!supportPreviewFileType.includes(fileSuffix)) {
          return '该格式暂不支持预览'
        }
      }
      return '暂无数据'
    })

    return {
      canPreview,
      description,
      pageState
    }
  }
}
